import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
} from '@ionic/react';
import { usePageView } from '../hooks/useLoggerInit';
import { useI18n } from '../i18n/I18nProvider';

const TermsPage: React.FC = () => {
  // Track page view
  usePageView('terms');
  const { t } = useI18n();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" text={t('common.actions.back')} />
          </IonButtons>
          <IonTitle>{t('legal.terms.title')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      
      <IonContent fullscreen className="ion-padding">
        <div className="legal-content">
          <h1>{t('legal.terms.title')}</h1>
          <p className="last-updated">
            {t('legal.terms.lastUpdated', { date: 'December 19, 2024' })}
          </p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Users Web App ("the App"), you accept and agree to be bound by 
              the terms and provisions of this agreement. If you do not agree to these terms, 
              please do not use the App.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              Users Web App provides a cross-platform user management solution available on web, 
              iOS, and Android platforms. The service includes user authentication, profile 
              management, and activity tracking features.
            </p>
          </section>

          <section>
            <h2>3. User Accounts</h2>
            <p>
              To use certain features of the App, you must register for an account. You agree to:
            </p>
            <ul>
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorized use of your account</li>
              <li>Accept responsibility for all activities under your account</li>
            </ul>
          </section>

          <section>
            <h2>4. User Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the App for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to any part of the App</li>
              <li>Interfere with or disrupt the App or servers</li>
              <li>Transmit any viruses or malicious code</li>
              <li>Collect user information without consent</li>
            </ul>
          </section>

          <section>
            <h2>5. Intellectual Property</h2>
            <p>
              The App and its original content, features, and functionality are owned by 
              Users Web App and are protected by international copyright, trademark, patent, 
              trade secret, and other intellectual property laws.
            </p>
          </section>

          <section>
            <h2>6. Limitation of Liability</h2>
            <p>
              In no event shall Users Web App be liable for any indirect, incidental, special, 
              consequential, or punitive damages, including loss of profits, data, or other 
              intangible losses resulting from your use of the App.
            </p>
          </section>

          <section>
            <h2>7. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of 
              any material changes by posting the new terms on the App. Your continued use of 
              the App after such modifications constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2>8. Contact Information</h2>
            <p>
              If you have any questions about these Terms & Conditions, please contact us at:
            </p>
            <p><strong>Email:</strong> support@users.web.app</p>
          </section>
        </div>

        <style>{`
          .legal-content {
            max-width: 800px;
            margin: 0 auto;
            padding-bottom: 48px;
          }

          .legal-content h1 {
            font-size: 28px;
            font-weight: 700;
            color: var(--ion-text-color);
            margin-bottom: 8px;
          }

          .legal-content .last-updated {
            color: var(--ion-color-medium);
            font-size: 14px;
            margin-bottom: 32px;
          }

          .legal-content section {
            margin-bottom: 32px;
          }

          .legal-content h2 {
            font-size: 20px;
            font-weight: 600;
            color: rgba(var(--ion-text-color-rgb), 0.92);
            margin-bottom: 12px;
          }

          .legal-content p {
            font-size: 16px;
            line-height: 1.6;
            color: var(--ion-text-color);
            margin-bottom: 12px;
          }

          .legal-content ul {
            padding-left: 24px;
            margin-bottom: 12px;
          }

          .legal-content li {
            font-size: 16px;
            line-height: 1.6;
            color: var(--ion-text-color);
            margin-bottom: 8px;
          }
        `}</style>
      </IonContent>
    </IonPage>
  );
};

export default TermsPage;

